import React from 'react'
import { withRouter } from 'react-router-dom'

import { PATHS } from 'Config/Routing/paths'

import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { PageTitle } from 'Components/PageTitle'

import { CountryHeaderNav } from 'Containers/Country/Page/HeaderNav'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'

import CountriesIcon from 'Assets/Images/icons/countries'
import StyledBreadcrumbs from '../../../Components/StyledBreadcrumbs'

const CountryPage = props => {
  const {
    history,
    country: { id, name, code },
    children,
    breadcrumbs = [],
    style,
  } = props

  return (
    <div style={style}>
      <LayoutDashboard>
        <StyledBreadcrumbs
          icon={<CountriesIcon style={{ width: 24 }} />}
          breadcrumbs={[
            {
              label: 'Countries',
              link: PATHS.main.dashboard + PATHS.dashboard.countries,
            },
            {
              label: name,
            },

            ...breadcrumbs,
          ]}
        />
        <PageTitle>{name}</PageTitle>
      </LayoutDashboard>
      <div style={{ backgroundColor: '#FFFFFF' }}>
        <CountryHeaderNav countryId={id} countryCode={code} history={history} />
        <HideWhenBlocked>{children}</HideWhenBlocked>
      </div>
    </div>
  )
}

export default withRouter(CountryPage)
